exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".containAll {\n  background: #f5f5f5 !important;\n  height: 100vh;\n}\n.content {\n  position: relative;\n  overflow: auto;\n}\n.has-bread-content {\n  padding: 0 10px;\n  -ms-flex: auto;\n      flex: auto;\n}\n", ""]);

// exports
